import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { PhoneIcon } from '@heroicons/react/24/outline'

export default function CTABanner() {
  return (
    <section className="py-20 bg-primary text-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-4">
            Ready to Start Your Driving Journey?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Join thousands of successful graduates. Enroll today and take the first step toward becoming a confident, safe driver.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link
                to="/register"
                className="inline-flex items-center gap-2 px-8 py-4 bg-accent text-primary font-heading font-semibold rounded-full hover:shadow-lift transition-all"
              >
                Register Now <span>&gt;</span>
              </Link>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <a
                href="tel:540-615-2418"
                className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white text-white font-heading font-semibold rounded-full hover:bg-white hover:text-primary transition-colors"
              >
                <PhoneIcon className="w-5 h-5" />
                Call 703-373-2564
              </a>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

